import { ListItem, ListItemText } from "@mui/material";
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const DragItem = ({ itemObject }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: itemObject.id,
    data: { type: "field", name: itemObject.columnName }
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0 : 1,
        cursor: "grab"
      }}
    >
      <ListItem sx={{ pl: 0, pr: 0 }}>
        <ListItemText
          primaryTypographyProps={{ style: { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" } }}
          primary={itemObject.columnName}
        />
      </ListItem>
    </div>
  );
};

export default DragItem;
